export default __webpack_public_path__ + "static/media/ep6TN1.77d1648a.jpg";